var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",class:{
    'footer--scrollable': _vm.$route.meta.isScrollable,
    'footer--info-hidden': _vm.$route.meta.isFooterInfoHidden,
  }},[_c('div',{staticClass:"footer__inner"},[_c('a',{staticClass:"footer__email",attrs:{"href":"mailto:avalon.theresistance@gmail.com"}},[_vm._v("\n      Contact Us\n    ")]),_c('avl-paypal-donation',{staticClass:"footer__donate"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }